module.exports = __webpack_public_path__ + "images/pro/img-pro-security@2x-4f0f9bb3ab2d8dde97f0dc006c7e8995.png";